import { render, staticRenderFns } from "./DonationCard.vue?vue&type=template&id=09472201&scoped=true&"
import script from "./DonationCard.vue?vue&type=script&lang=js&"
export * from "./DonationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09472201",
  null
  
)

export default component.exports